import React, { useEffect, useState } from 'react'
import { Button, Select, TextInput } from 'components/Form'
import { ConfirmationModal, Modal, SimpleTable, Tooltip } from 'components/Ui'
import { getApiData, deleteApiRecord, createApiRecord, updateApiRecord } from 'services/WoocommerceService'
import { Field, Form, Formik } from 'formik'
import { AiOutlinePlus } from 'react-icons/ai'
import { HiOutlinePencil, HiOutlineTrash } from 'react-icons/hi'
import { Success } from 'utils/alerts'
import * as Yup from 'yup'
import { activeStatus, fullfillmentStatus } from 'components/helper'
import { InventoryUpdateMethodOptions } from 'utils/options'

const validationSchema = Yup.object().shape({
    company: Yup.string().required('company field is required'),
    customer: Yup.string().required('customer field is required'),
    store_url: Yup.string().required('store url field is required'),
    consumer_key: Yup.string().required('consumer key field is required'),
    consumer_secret: Yup.string().required('consumer secret field is required'),
    inventory_update_method: Yup.string().required('inventory update method field is required'),
})

export default function WooCommerceIntegrationTabView({ companyData, customersData, record }) {
    const [data, setData] = useState([])
    const [selectedData, setSelectedData] = useState()
    const [open, setOpen] = useState(false)

    useEffect(() => {
        if (record) {
            getData({ company: record?.company?.id, customer: record?.id })
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [record])

    const getData = data => {
        getApiData(data)
            .then(response => {
                if (response.data) {
                    setData(response.data?.results)
                }
            })
            .catch(error => console.log('Error fetching order type data: ', error))
    }

    const handleStatus = (id, data) => {
        delete data.image
        updateApiRecord(id, data)
            .then(() => {
                Success('Status Updated Successfully!')
                getData({ company: record?.company?.id, customer: record?.id })
            })
            .catch(error => console.log('Error: ', error))
    }

    const handleDelete = id => {
        deleteApiRecord(id)
            .then(() => {
                Success('Deleted Successfully!')
                getData({
                    company: record?.company?.id,
                    customer: record?.id,
                })
            })
            .catch(error => console.log('Error: ', error))
    }

    const handleSubmit = data => {
        if (selectedData?.id) {
            updateApiRecord(selectedData?.id, data)
                .then(() => {
                    getData({ company: record?.company?.id, customer: record?.id })
                    Success('Updated Successfully!')
                    setOpen(false)
                    setSelectedData()
                })
                .catch(error => console.log('Error: ', error))
        } else {
            createApiRecord(data)
                .then(() => {
                    getData({ company: record?.company?.id, customer: record?.id })
                    Success('Created Successfully!')
                    setOpen(false)
                    setSelectedData()
                })
                .catch(error => console.log('Error: ', error))
        }
    }

    return (
        <div>
            <div className="flex items-center justify-end mb-4">
                <Button
                    className="text-white border-[#F05540] bg-[#F05540] dark:border-[#F05540] dark:bg-[#F05540]"
                    onClick={() => setOpen(true)}
                >
                    <AiOutlinePlus size={20} /> Add New
                </Button>
            </div>
            <div className="grid grid-cols-1 gap-x-4 gap-y-4">
                <SimpleTable>
                    <thead>
                        <SimpleTable.TR>
                            <SimpleTable.TH>Store url</SimpleTable.TH>
                            <SimpleTable.TH>Company</SimpleTable.TH>
                            <SimpleTable.TH>Customer</SimpleTable.TH>
                            <SimpleTable.TH>Status</SimpleTable.TH>
                            <SimpleTable.TH>Fulfillment Sync</SimpleTable.TH>
                            <SimpleTable.TH>Action</SimpleTable.TH>
                        </SimpleTable.TR>
                    </thead>
                    <tbody>
                        {(data || [])?.map((row, index) => (
                            <SimpleTable.TR key={`row-${index}`}>
                                <SimpleTable.TD>{row?.store_url}</SimpleTable.TD>
                                <SimpleTable.TD>{row?.company?.code}</SimpleTable.TD>
                                <SimpleTable.TD>{row?.customer?.customer_code}</SimpleTable.TD>
                                <SimpleTable.TD>
                                    {/* {checkPermission('woocommerce-integration', 'edit') ? ( */}
                                    <ConfirmationModal
                                        onConfirm={() => {
                                            handleStatus(row.id, { is_active: !row.is_active })
                                        }}
                                    >
                                        {activeStatus(row.is_active)}
                                    </ConfirmationModal>
                                    {/* ) : (
                                        activeStatus(row.is_active)
                                    )} */}
                                </SimpleTable.TD>
                                <SimpleTable.TD>
                                    {/* {checkPermission('woocommerce-integration', 'edit') ? ( */}
                                    <ConfirmationModal
                                        onConfirm={() => {
                                            handleStatus(row.id, { enable_fulfillment_sync: !row.enable_fulfillment_sync })
                                        }}
                                    >
                                        {fullfillmentStatus(row.enable_fulfillment_sync)}
                                    </ConfirmationModal>
                                    {/* ) : (
                                        fullfillmentStatus(row.enable_fulfillment_sync)
                                    )} */}
                                </SimpleTable.TD>
                                <SimpleTable.TD>
                                    <div className="flex items-center justify-center gap-3">
                                        {/* {checkPermission('order-type', 'edit') ? ( */}
                                        <Tooltip title={'Edit'}>
                                            <span
                                                onClick={() => {
                                                    setSelectedData({
                                                        ...row,
                                                        company: row?.company.id || '',
                                                        customer: row?.customer.id || '',
                                                    })
                                                    setOpen(true)
                                                }}
                                                className="hover:text-primary"
                                            >
                                                <HiOutlinePencil size={20} />
                                            </span>
                                        </Tooltip>
                                        {/* ) : null} */}
                                        {/* {checkPermission('order-type', 'delete') ? ( */}
                                        <Tooltip title={'Delete'}>
                                            <ConfirmationModal
                                                message={'Are you sure you want to delete this record!'}
                                                onConfirm={() => handleDelete(row.id)}
                                            >
                                                <span className="hover:text-danger">
                                                    <HiOutlineTrash size={20} />
                                                </span>
                                            </ConfirmationModal>
                                        </Tooltip>
                                        {/* ) : null} */}
                                    </div>
                                </SimpleTable.TD>
                            </SimpleTable.TR>
                        ))}
                    </tbody>
                </SimpleTable>
            </div>
            <Modal
                show={open}
                maxWidth="4xl"
                onClose={() => {
                    setOpen(false)
                    setSelectedData()
                }}
            >
                <div className="flex flex-col gap-1 m-3">
                    <h2 className="font-semibold text-black text-title-md">
                        {selectedData ? 'Update WooCommerce Integration' : 'Add New WooCommerce Integration'}
                    </h2>
                </div>
                <div className="flex flex-col items-center">
                    <div className="w-full bg-white border rounded-sm overflow-auto max-h-150 border-stroke shadow-default dark:border-strokedark dark:bg-boxdark">
                        <div className="flex flex-col gap-3 p-6">
                            <Formik
                                initialValues={
                                    selectedData
                                        ? selectedData
                                        : {
                                              company: record?.company?.id,
                                              customer: record?.id,
                                              store_url: '',
                                              consumer_key: '',
                                              consumer_secret: '',
                                              inventory_update_method: '',
                                          }
                                }
                                validationSchema={validationSchema}
                                onSubmit={values => {
                                    handleSubmit(values)
                                }}
                            >
                                {({ values, touched, errors }) => (
                                    <Form>
                                        <div className="grid grid-cols-1 gap-x-4 gap-y-4 md:grid-cols-4">
                                            <Field name="company">
                                                {({ field, form }) => (
                                                    <Select
                                                        id="company"
                                                        name="company"
                                                        label="Company"
                                                        placeholder="Company"
                                                        className="md:col-span-2"
                                                        value={values?.company}
                                                        options={companyData}
                                                        onChange={e => form.setFieldValue(field.name, e.target.value)}
                                                        error={touched.company && errors.company}
                                                        message={errors.company}
                                                        disabled
                                                    />
                                                )}
                                            </Field>
                                            <Field name="customer">
                                                {({ field, form }) => (
                                                    <Select
                                                        id="customer"
                                                        name="customer"
                                                        label="Customer"
                                                        placeholder="Customer"
                                                        className="md:col-span-2"
                                                        value={values?.customer}
                                                        options={customersData}
                                                        onChange={e => form.setFieldValue(field.name, e.target.value)}
                                                        error={touched.customer && errors.customer}
                                                        message={errors.customer}
                                                        disabled
                                                    />
                                                )}
                                            </Field>
                                            <Field name="store_url">
                                                {({ field, form }) => (
                                                    <>
                                                        <TextInput
                                                            type="text"
                                                            className="md:col-span-2"
                                                            label="Store url"
                                                            name="store_url"
                                                            error={errors.store_url && touched.store_url}
                                                            message={errors.store_url}
                                                            value={values?.store_url}
                                                            onChange={e => form.setFieldValue(field.name, e.target.value)}
                                                        />
                                                    </>
                                                )}
                                            </Field>
                                            <Field name="consumer_key">
                                                {({ field, form }) => (
                                                    <TextInput
                                                        type="text"
                                                        className="md:col-span-2"
                                                        label="Consumer key"
                                                        name="consumer_key"
                                                        error={errors.consumer_key && touched.consumer_key}
                                                        message={errors.consumer_key}
                                                        value={values?.consumer_key}
                                                        onChange={e => form.setFieldValue(field.name, e.target.value)}
                                                    />
                                                )}
                                            </Field>
                                            <Field name="consumer_secret">
                                                {({ field, form }) => (
                                                    <TextInput
                                                        type="text"
                                                        className="md:col-span-2"
                                                        label="Consumer secret key"
                                                        name="consumer_secret"
                                                        error={errors.consumer_secret && touched.consumer_secret}
                                                        message={errors.consumer_secret}
                                                        value={values?.consumer_secret}
                                                        onChange={e => form.setFieldValue(field.name, e.target.value)}
                                                    />
                                                )}
                                            </Field>
                                            <Field name="inventory_update_method">
                                                {({ field, form }) => (
                                                    <Select
                                                        id="inventory_update_method"
                                                        name="inventory_update_method"
                                                        label="Inventory Update Method"
                                                        placeholder="Inventory Update Method"
                                                        className="md:col-span-2"
                                                        value={values?.inventory_update_method}
                                                        options={InventoryUpdateMethodOptions}
                                                        onChange={e => form.setFieldValue(field.name, e.target.value)}
                                                        error={touched.inventory_update_method && errors.inventory_update_method}
                                                        message={errors.inventory_update_method}
                                                    />
                                                )}
                                            </Field>
                                        </div>
                                        <div className="flex items-center justify-end gap-4 mt-3">
                                            <Button
                                                className="h-10 w-18 text-primary border border-primary dark:text-secondary dark:border-secondary"
                                                type="button"
                                                onClick={() => {
                                                    setOpen(false)
                                                    setSelectedData()
                                                }}
                                            >
                                                Discard
                                            </Button>
                                            <Button
                                                type="submit"
                                                className="flex items-center justify-center px-6 py-2 text-white transition border rounded-lg cursor-pointer hover:bg-opacity-90 border-primary bg-primary dark:border-secondary dark:bg-secondary"
                                            >
                                                Save
                                            </Button>
                                        </div>
                                    </Form>
                                )}
                            </Formik>
                        </div>
                    </div>
                </div>
            </Modal>
        </div>
    )
}
